import Raj from '../Assets/Raj .svg'
import Akshara from '../Assets/Akshara.svg'

export const AboutUsContents = {
    WelcomeTitle: "Welcome to Rav Business Stream Inc",
    Introduction: "Rav Business Stream is incorporated as a Technology Consulting services and Software product development firm. Head quartered in Texas and Offshore development centers in India, we have involved in creating strategy, implementing, deploying, and supporting a wide range of solutions for clients worldwide. Our clients include a varied set of Fortune 500, free essay example mid-sized and startup companies. They count on us to provide them with timely, high-quality work and they return to us because we’re reliable, experienced and easy to work with.",
    MissionHeading: "Our Mission",
    MissionDescription: "Agilewit team consists of highly skilled professionals based in USA and India. Our team delivery model leverages global talent, agile processes and multiple time zones to help our clients save time and money without compromising the quality. Our guiding principles are based on developing long term relationship with our customers, partners and employees. As a result, we have grown quickly, earning ourselves recognition as a fastest growing Incorporate in USA. Even more prominently, we have done this while building a culture that puts people first.",
    PartnersOpinionTitlePartOne: "What Our",
    PartnersOpinionTitlePartTwo: "Partners",
    PartnersOpinionTitlePartThree: "Say"
}

export const Partners = [
    {
        PartnerName: "Raj Kumar",
        PartnerIcon: Raj,
        PartnerCompany: "HCL",
        PartnerOpinion: "“ The Agilewit team demonstrates exceptional expertise and efficiency in problem-solving. I highly recommend Rav Business Stream Inc. for data science projects. Their insights and support were instrumental in deriving accurate predictions and uncovering valuable business patterns.”"
    },
    {
        PartnerName: "Akshara",
        PartnerIcon: Akshara,
        PartnerCompany: "Director Of SK Instistution",
        PartnerOpinion: "“The UX/UI team at Agilewits Solutions Inc. delivered exceptional professional designs for my institution. Their attention to detail and creativity exceeded my expectations. I highly recommend Agilewits to any business partners looking for top-tier design solutions.”"
    }
]


export const MissionInfoArray=[
    {
        MissionTitle:"Improve Your Business",
        MissionDescription:"Help our customers grow and improve their business."
    
    },
    {
        MissionTitle:"Workplace",
        MissionDescription:"Create a workplace where employees can explore, learn and grow"
    
    },
    {
        MissionTitle:"Best Investment",
        MissionDescription:"Deliver the best return on investment and create long-term value for our shareholders."
    
    },
    {
        MissionTitle:"Contributions",
        MissionDescription:"Make contributions to enhance the well-being of the communities where we live and work."
    
    },
    
]

